const parseSystemDataValue = (systemData) => {
  if (!systemData) {
    return null;
  }

  if (typeof systemData === "string") {
    try {
      return JSON.parse(systemData);
    } catch (error) {
      console.error("Failed to parse systemData payload", error);
      return null;
    }
  }

  if (typeof systemData === "object") {
    return systemData;
  }

  return null;
};

export const getSystemEnvironments = (systemData) => {
  const parsedSystemData = parseSystemDataValue(systemData);
  if (!parsedSystemData) {
    return [];
  }

  if (
    parsedSystemData.json &&
    typeof parsedSystemData.json === "string" &&
    parsedSystemData.json.trim()
  ) {
    try {
      const embeddedSystemData = JSON.parse(parsedSystemData.json);
      if (
        embeddedSystemData?.environments &&
        typeof embeddedSystemData.environments === "object"
      ) {
        return Object.values(embeddedSystemData.environments);
      }
    } catch (error) {
      console.error("Failed to parse embedded systemData.json payload", error);
    }
  }

  if (
    parsedSystemData.environments &&
    typeof parsedSystemData.environments === "object"
  ) {
    return Object.values(parsedSystemData.environments);
  }

  return [];
};
